import axios from 'axios';
import authService from './authService';
import { API_BASE_URL } from '../config/api';

const BASE_URL = `${API_BASE_URL}/client-quotes/`;

const getHeaders = () => ({
  'Authorization': `Token ${authService.getToken()}`,
  'Content-Type': 'application/json'
});

const clientQuoteService = {
  listClientQuotes: (filterField = null, filterValue = null, sortBy = '-created_at', page = 1, createdFrom = null, createdTo = null) => {
    const params = {
      sort_by: sortBy,
      page: page
    };
    if (filterField && filterValue) {
      params.filter_field = filterField;
      params.filter_value = filterValue;
    }
    if (createdFrom) {
      params.created_from = createdFrom;
    }
    if (createdTo) {
      params.created_to = createdTo;
    }
    return axios.get(BASE_URL, {
      headers: getHeaders(),
      params
    });
  },

  getClientQuoteById: (id) => {
    return axios.get(`${BASE_URL}${id}/`, {
      headers: getHeaders()
    });
  },

  createClientQuote: (data) => {
    return axios.post(BASE_URL, data, {
      headers: getHeaders()
    });
  },

  updateClientQuote: (id, data) => {
    return axios.put(`${BASE_URL}${id}/`, data, {
      headers: getHeaders()
    });
  },

  deleteClientQuote: (id) => {
    return axios.delete(`${BASE_URL}${id}/`, {
      headers: getHeaders()
    });
  },

  exportPDF: (id) => {
    return axios.get(`${BASE_URL}${id}/export_pdf/`, {
      headers: getHeaders(),
      responseType: 'blob'
    }).then(response => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', response.headers['content-disposition']?.split('filename=')[1]?.replace(/"/g, '') || 'quote.pdf');
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);
    });
  },

  convertToSale: (id) => {
    return axios.post(`${BASE_URL}${id}/convert_to_sale/`, {}, {
      headers: getHeaders()
    });
  }
};

export default clientQuoteService;
